import React, { Fragment } from 'react';
import { MultilangFormEditData, MultiLangInput } from '@carlito/dashboard-ui';
import { KeyBoard } from '@carlito/shared-ui';
import { useScreenKeyboard } from '../../KeyBoard/useScreenKeyboard';
import { useFormikContext } from 'formik';
import { EventBookingFormValues } from '@carlito/bookito-client';
import { useTranslation } from 'react-i18next';
import { isMultiLangContent } from '@carlito/intl';

type Props = {
  isBookingRefEnabled: boolean;
  isRoomNrEnabled: boolean;
  isKioskMode?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
function RoomNumberAndBookingRefField(props: Props) {
  const { isBookingRefEnabled, isKioskMode, isRoomNrEnabled } = props;

  const { values, getFieldProps, setFieldValue, setFieldTouched, status } =
    useFormikContext<EventBookingFormValues>();

  const bookingRef = values.bookingRef;
  const roomNr = values.participants?.[0]?.roomNr; // bookedBy?.roomNr
  const { t } = useTranslation();

  const { keyboardType, focusedInput, handleKeyPress, setFocusedInput, handleSetFocus } =
    useScreenKeyboard({
      defaultKeyboardType: 'Alphabetic',
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputName = e.target.name;
        console.log('RoomNumberAndBookingRefField', e);

        const { onChange } = getFieldProps(inputName);
        setFieldTouched(inputName, true);
        onChange(e);
        props?.onChange?.(e);
      },
    });

  return (
    <Fragment>
      <div className={'flex items-center justify-between w-full'}>
        {!bookingRef && isRoomNrEnabled && (
          <div className="flex-1">
            <MultiLangInput
              onFocus={(e: any) => {
                if (!isKioskMode) return;
                handleSetFocus(e.target);
              }}
              onBlur={() => {
                setFocusedInput(null);
              }}
              name="participants[0].roomNr"
              label={t('Room number')}
              placeholder={`${t('Room number')} (${t('optional')})`}
              type="text"
              isAutoCompleteRequired={!isKioskMode}
            />
          </div>
        )}
        {isBookingRefEnabled && (
          <Fragment>
            {!bookingRef && !roomNr && <div className={'pt-5 px-5 flex-shrink-0'}>/</div>}
            {!roomNr && (
              <div className="flex-1">
                <MultiLangInput
                  onFocus={(e: any) => {
                    if (!isKioskMode) return;
                    handleSetFocus(e.target);
                  }}
                  onBlur={() => {
                    setFocusedInput(null);
                  }}
                  name="bookingRef"
                  label={t('booking-reference')}
                  placeholder={`${t('booking-reference')} (${t('optional')})`}
                  type="text"
                  isAutoCompleteRequired={!isKioskMode}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      {Boolean(focusedInput) && (
        <KeyBoard
          canChangeKeyboardType={true}
          handleKeyPress={handleKeyPress}
          keyboardType={keyboardType}
        />
      )}
    </Fragment>
  );
}

export default RoomNumberAndBookingRefField;
